'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$ItemDeleted(item) {
  this.Kv = null;
  this.Kv = item;
}
export { $c_Lpresto_crud$ItemDeleted as $c_Lpresto_crud$ItemDeleted };
$p = $c_Lpresto_crud$ItemDeleted.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$ItemDeleted;
/** @constructor */
function $h_Lpresto_crud$ItemDeleted() {
}
export { $h_Lpresto_crud$ItemDeleted as $h_Lpresto_crud$ItemDeleted };
$h_Lpresto_crud$ItemDeleted.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_crud$ItemDeleted) && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.Kv, x$0.Kv)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "ItemDeleted";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kv;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$ItemDeleted(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ja)));
}
export { $isArrayOf_Lpresto_crud$ItemDeleted as $isArrayOf_Lpresto_crud$ItemDeleted };
var $d_Lpresto_crud$ItemDeleted = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$ItemDeleted, "presto.crud$ItemDeleted", ({
  ja: 1,
  bw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$ItemDeleted as $d_Lpresto_crud$ItemDeleted };
//# sourceMappingURL=presto.crud$-Item-Deleted.js.map
